import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

import { library } from '@fortawesome/fontawesome-svg-core'

// import { cloneDeep } from 'lodash'
import SwitchPortal from '@/components/edit/SwitchPortal/index.vue'
import String from '@/components/edit/String/index.vue'

import Control from '@/helpers/control'

import { faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faTrashAlt)

interface Item {
	label: string
}

@Component({
	components: {
		SwitchPortal,
		String,
	},
})
export default class FieldPercentagePortal extends Vue {
	@Prop({ default: 0 }) model!: number
	@Prop() name!: string
	@Prop() status!: string

	money = {
		decimal: ',',
		thousands: '.',
		precision: 2,
		masked: false,
		suffix: ' %',
	}

	updatableModel = 0
	created() {
		if (typeof this.model === 'number') {
			this.updatableModel = this.model * 100
		}
	}

	onInput() {
		this.processChange()
	}

	onUpdate() {
		let emitValue = 0
		if (this.updatableModel) {
			emitValue = this.updatableModel / 100
		}
		this.$emit('input', this.name, emitValue)
	}

	processChange = debounce(() => {
		this.onUpdate()
	}, 500)
}

function debounce(func, timeout = 1) {
	let timer
	return (...args) => {
		clearTimeout(timer)
		timer = setTimeout(() => {
			// @ts-ignore
			func.apply(this, args)
		}, timeout)
	}
}
